const partners = [
  "VIT University",
  "Kingston Engineering College",
  "MGR University Off Campus — Arni",
  "ACS Group",
  "SCG-IoT",
  "Green Connect",
];

export const PartnersMarquee = () => (
  <section data-testid="partners-marquee" className="border-y border-ink py-8 md:py-10 overflow-hidden bg-[#F3F3F1]">
    <div className="container-wide flex items-center justify-between mb-6">
      <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-gray-500">
        Trusted by institutions and partners
      </p>
      <span className="hidden md:inline font-mono-cust text-[11px] text-gray-400">— in good company —</span>
    </div>
    <div className="relative w-full overflow-hidden">
      <div className="marquee">
        {[...partners, ...partners].map((p, i) => (
          <div
            key={i}
            data-testid={`partner-${i}`}
            className="font-heading text-2xl md:text-4xl tracking-tighter text-ink/60 hover:text-[#9F381A] transition-colors whitespace-nowrap"
          >
            {p} <span className="text-ink/20 mx-8">/</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PartnersMarquee;
